module.exports = __webpack_public_path__ + "static/media/gi.0ad62abd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gi.svg
// module id = 128
// module chunks = 0